module.exports = {"classes":["feedback-page"],"title":"Product Feedback","metas":{},"opengraph":{},"twittercard":{"twitter:title":"Product Feedback","twitter:description":"Use this form to share your ideas, feedback and feature requests to the Auth0 Product Team.","twitter:image":[{"src":"https://cdn.auth0.com/website/assets/pages/feedback/img/Feedback_Page-c07ebd14c1.png"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/feedback/metadata.json
// module id = 1498
// module chunks = 0